'use strict';

'use strict';

import 'document-register-element';
import dispatcher from '../dispatcher';

class InputFile extends HTMLLabelElement{
  constructor(self) {
    self = super(self);
    self.init.call(self);
  }
  init() {

  }
  connectedCallback() {
    this.input = this.querySelector('input');
    this.nameArea = this.querySelector('.file-name');
    this.initText = this.nameArea.innerHTML;
    this.clear = this.querySelector('.file-clear');

    this.input.addEventListener('change', () => {
      let name = Object.values(this.input.files).map(file => file.name).join(', ');

      if (name.length) {
        this.nameArea.innerHTML = name;
      } else {
        this.nameArea.innerHTML = this.initText;
      }
    });

    if (this.clear) {
      this.clear.addEventListener('click', (e) => {
        if (!this.input.value) return;

        e.preventDefault();

        this.input.value = '';
        this.nameArea.innerHTML = this.initText;
      });
    }
  }
  disconnectedCallback() {
  }

}

window.customElements.define('input-file', InputFile, {extends: 'label'});